import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ParticlesBg from "../Background/ParticlesBg";
import contactImg from "../../Assets/workanywhere.svg";
import { AiFillGithub, AiFillLinkedin, AiOutlineMail } from "react-icons/ai";

function Contact() {
  const iconLinkStyle = {
    color: "white",
    marginRight: "20px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",
    cursor: "pointer",
  };

  return (
    <Container fluid className="contact-section" style={{ position: "relative" }}>
      {/* Background layer (should not capture clicks) */}
      <ParticlesBg />

      {/* Foreground content layer (forced above background) */}
      <div
        style={{
          position: "relative",
          zIndex: 9999,
          pointerEvents: "auto",
        }}
      >
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              className="home-header"
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Get In Touch{" "}
                <span role="img" aria-label="contact">
                  📬
                </span>
              </h1>

              <p style={{ color: "white", fontSize: "1.2rem" }}>
                I’m always happy to talk about data engineering roles, cloud projects,
                or potential collaborations
              </p>

              <div style={{ fontSize: "2.2rem", marginTop: "20px" }}>
                <a
                  href="mailto:chenyu.wu.dev@gmail.com"
                  style={iconLinkStyle}
                  aria-label="Email"
                >
                  <AiOutlineMail />
                </a>

                <a
                  href="https://www.linkedin.com/in/chenyu-wu-data-engineer/"
                  target="_blank"
                  rel="noreferrer"
                  style={iconLinkStyle}
                  aria-label="LinkedIn"
                >
                  <AiFillLinkedin />
                </a>

                <a
                  href="https://github.com/Shyqwq5"
                  target="_blank"
                  rel="noreferrer"
                  style={{ ...iconLinkStyle, marginRight: 0 }}
                  aria-label="GitHub"
                >
                  <AiFillGithub />
                </a>
              </div>
            </Col>

            <Col md={5} style={{ paddingTop: "120px", paddingBottom: "50px" }}>
              <img
                src={contactImg}
                alt="contact illustration"
                className="img-fluid"
                style={{ maxHeight: "380px", pointerEvents: "none" }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </Container>
  );
}

export default Contact;
